/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'up-trend-arrow': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6 13.4a.8.8 0 01-.8-.8V1.4a.8.8 0 011.6 0v11.2a.8.8 0 01-.8.8z" _fill="#00DCA4"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M5.434.834a.8.8 0 011.132 0l4.8 4.8a.8.8 0 01-1.132 1.132l-4.8-4.8a.8.8 0 010-1.132z" _fill="#00DCA4"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M.634 6.766a.8.8 0 010-1.132l4.8-4.8a.8.8 0 011.132 1.132l-4.8 4.8a.8.8 0 01-1.132 0z" _fill="#00DCA4"/>'
  }
})
